var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnackbarWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 8.8715C12.4093 8.8715 12.7409 9.19911 12.7409 9.60324V13.0241C12.7409 13.4282 12.4093 13.7558 12.0002 13.7558C11.5912 13.7558 11.2595 13.4282 11.2595 13.0241V9.60324C11.2595 9.19911 11.5912 8.8715 12.0002 8.8715Z",
    fill: "#FFC649"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9724 15.9968C12.9724 16.5272 12.5372 16.9572 12.0002 16.9572C11.4633 16.9572 11.0281 16.5272 11.0281 15.9968C11.0281 15.4663 11.4633 15.0364 12.0002 15.0364C12.5372 15.0364 12.9724 15.4663 12.9724 15.9968Z",
    fill: "#FFC649"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2356 5.17227C12.6894 4.22721 11.3111 4.22721 10.7648 5.17227L3.67347 17.4327C3.13099 18.3698 3.81567 19.5365 4.90895 19.5365H19.0915C20.1835 19.5365 20.869 18.3702 20.327 17.4327L13.2356 5.17227ZM14.522 4.44662C13.4073 2.51779 10.5932 2.51779 9.4784 4.44662L2.38736 16.7064C1.28018 18.6194 2.67842 21 4.90895 21H19.0915C21.3215 21 22.7192 18.6193 21.6132 16.7067L14.522 4.44662Z",
    fill: "#FFC649"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnackbarWarning);
export default __webpack_public_path__ + "static/media/snackbar-warning.a7e60c89406ab10db838180ad08a050f.svg";
export { ForwardRef as ReactComponent };